/**
 * @desc 财务画像-历史处罚-深圳证券交易所
 * @author caoyx
 */
import React, { PureComponent } from 'react';
import GroupBox from '../../../common/groupBox/GroupBox';
import Pagination from '../../../common/pagination/Pagination';
import SZSE from './SZSE';
import {commonRequest} from '../../common/commons';
import {addDataIndex, isNotEmpty} from '../../../../utils/util';
import {Table} from 'antd';
import {ssePromise, publicCompany, sseEnquiry} from './columns';
import {getSSEPromise, getSSEEnquiry, getSSEMeasures} from '../../../../services/financialPicture/historyPunish';

export default class SSE extends PureComponent {
    constructor(props) {
        super(props);
        this.sseNav = [];
        this.szseNav = [];
        this.state = {
            loading: true,
            degreePageSize: 10,
            degreePageNum: 1,
            degreeTotal: 0,
            degree: [],
            enquiryPageSize: 10,
            enquiryPageNum: 1,
            enquiryTotal: 0,
            enquiry: [],
            measuresPageSize: 10,
            measuresPageNum: 1,
            measuresTotal: 0,
            measures: []
        };
    }

    componentDidMount() {
        this.getDegreeData();
        this.getEnquiryData();
        this.getMeasuresData();
    }

    // 获取左侧导航信息
    sseProps = () => {
        const {degree, enquiry, measures} = this.state;
        const { szseNav } = this.props;
        let sseSubNav = [];
        if(isNotEmpty(degree) || isNotEmpty(enquiry) || isNotEmpty(measures)) {
            sseSubNav = [
                { name: '上海证券交易所-承诺履行', id: 'sse-promise' },
                { name: '上海证券交易所-监管问询', id: 'sse-adminis-enquiry' },
                { name: '上海证券交易所-监管措施', id: 'sse-adminis-measures' }
            ];
            this.sseNav = sseSubNav;
        } else if(isNotEmpty(this.szseNav)) {
            sseSubNav = [...this.szseNav];
        }else {
            sseSubNav = [];
        }
        szseNav && szseNav(sseSubNav);
    }

    // 获取子组件深圳证券交易所nav
    subNav = (nav) => {
        this.szseNav = nav;
    }
    
    // 上海证券交易所-承诺事项及履行情况
    getDegreeData = () => {
        const { degreePageNum, degreePageSize } = this.state;
        this.setState({
            loading: true
        });
        getSSEPromise(commonRequest({ pageNum: degreePageNum, pageSize: degreePageSize })).then(data => {
            data = data || {};
            this.setState({
                loading: false,
                degree: addDataIndex(data.results, degreePageNum, degreePageSize),
                degreeTotal: data.total
            }, () => {
                this.sseProps();
            });
        }).catch(() => {
            this.setState({
                loading: false
            });
        });
    };

    // 上海证券交易所-问询函件
    getEnquiryData = () => {
        const { enquiryPageNum, enquiryPageSize } = this.state;
        getSSEEnquiry(commonRequest({ pageNum: enquiryPageNum, pageSize: enquiryPageSize })).then(data => {
            data = data || {};
            this.setState({
                enquiry: addDataIndex(data.results, enquiryPageNum, enquiryPageSize),
                enquiryTotal: data.total
            }, () => {
                this.sseProps();
            });
        }).catch(() => {
            this.setState({
                enquiry: []
            });
        });
    };

    // 上海证券交易所-监管措施
    getMeasuresData = () => {
        const { measuresPageNum, measuresPageSize } = this.state;
        getSSEMeasures(commonRequest({ pageNum: measuresPageNum, pageSize: measuresPageSize })).then(data => {
            data = data || {};
            this.setState({
                measures: addDataIndex(data.results, measuresPageNum, measuresPageSize),
                measuresTotal: data.total
            }, () => {
                this.sseProps();
            });
        }).catch(() => {
            this.setState({
                measures: []
            });
        });
    };

    // 上海证券交易所 监管措施表格
    sseMeasures = () => {
        return [
            ...publicCompany,
            {
                title: '监管类型',
                dataIndex: 'notice_type',
                width: 90
            },
            {
                title: '处理事由',
                dataIndex: 'notice_measures',
                render: (v, d) => d.notice_measures.indexOf('div') < 0 ? d.notice_measures : '--'
            },
            {
                title: '涉及对象',
                dataIndex: 'notice_target',
                width: 90
            },
            {
                title: '处理日期',
                dataIndex: 'pubdate',
                width: 90
            }];
    }

    // 分页
    pageChange = (degreePageNum, degreePageSize) => {
        this.setState({
            degreePageNum,
            degreePageSize
        }, () => {
            this.getDegreeData();
        });
    };

    measuresChange = (measuresPageNum, measuresPageSize) => {
        this.setState({
            measuresPageNum,
            measuresPageSize
        }, () => {
            this.getMeasuresData();
        });
    };

    enquiryChange = (enquiryPageNum, enquiryPageSize) => {
        this.setState({
            enquiryPageNum,
            enquiryPageSize
        }, () => {
            this.getEnquiryData();
        });
    };

    render() {
        const { degreePageSize, degreePageNum, degreeTotal, degree, loading,
            enquiryPageSize, enquiryPageNum, enquiryTotal, enquiry,
            measuresPageSize, measuresPageNum, measuresTotal, measures
        } = this.state;
        return (
            <div>
                <SZSE subNav={this.subNav} />
                {isNotEmpty(this.sseNav) ? 
                    <div>
                        <GroupBox id={'sse-promise'} title={'上海证券交易所-承诺事项及履行情况'}>
                            <Table
                                pagination={false}
                                loading={loading}
                                bordered
                                rowKey="index"
                                dataSource={degree}
                                columns={ssePromise}
                                footer={() => degreeTotal > 10 ? <Pagination total={degreeTotal} current={degreePageNum} pageSize={degreePageSize} onChange={this.pageChange} /> : null}
                            />
                        </GroupBox>
                        <GroupBox id={'sse-enquiry-letters'} title={'上海证券交易所-问询函件'}>
                            <Table
                                pagination={false}
                                bordered
                                rowKey="index"
                                dataSource={enquiry}
                                columns={sseEnquiry}
                                footer={() => enquiryTotal > 10 ? <Pagination total={enquiryTotal} current={enquiryPageNum} pageSize={enquiryPageSize} onChange={this.enquiryChange} /> : null}
                            />
                        </GroupBox> 
                    
                        <GroupBox id={'sse-adminis-measures'} title={'上海证券交易所-监管措施'}>
                            <Table
                                pagination={false}
                                bordered
                                rowKey="index"
                                dataSource={measures}
                                columns={this.sseMeasures()}
                                footer={() => measuresTotal > 10 ? <Pagination total={measuresTotal} current={measuresPageNum} pageSize={measuresPageSize} onChange={this.measuresChange} /> : null}
                            />
                        </GroupBox>
                    </div> : ''
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/historyPunishment/subComponents/SSE.jsx